import { useState } from 'react';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { accionesDisponibles } from './accionesConfig';
import EmpleadosModal from '../../../empleados/empleadosModal/empleadosModal';
import './AccionesMasivasModal.scss';

const AccionesMasivasModal = ({
  open,
  onClose,
  onExecute,  // función que recibe (emp_id, option) 
  isProcessing = false
}) => {
  // Estados internos del modal
  const [accionSeleccionada, setAccionSeleccionada] = useState(null);
  const [filtroAplicar, setFiltroAplicar] = useState('todos');

  // Estados para EmpleadosModal
  const [isEmpleadosModalOpen, setIsEmpleadosModalOpen] = useState(false);
  const [selectedEmpleadoId, setSelectedEmpleadoId] = useState(null);
  const [selectedEmpleadoDesc, setSelectedEmpleadoDesc] = useState('');

  // ═══════════════════════════════════════════════════════════════════════════
  // Handlers
  // ═══════════════════════════════════════════════════════════════════════════
  const handleClose = () => {
    resetState();
    onClose();
  };

  const resetState = () => {
    setAccionSeleccionada(null);
    setFiltroAplicar('todos');
    setSelectedEmpleadoId(null);
    setSelectedEmpleadoDesc('');
  };

  const handleSelectAccion = (accion) => {
    setAccionSeleccionada(accion);
    setFiltroAplicar('todos');
    setSelectedEmpleadoId(null);
    setSelectedEmpleadoDesc('');
  };

  const handleVolverAcciones = () => {
    setAccionSeleccionada(null);
  };

  const handleEmpleadoIDChange = (id) => {
    setSelectedEmpleadoId(id);
  };

  const handleEmpleadoDescChange = (desc) => {
    setSelectedEmpleadoDesc(desc);
  };

  const handleEmpleadoSelect = () => {
    setIsEmpleadosModalOpen(false);
  };

  const handleEjecutarAccion = async () => {
    if (!accionSeleccionada) return;

    const emp_id = filtroAplicar === 'empleado' ? selectedEmpleadoId : null;
    const option = accionSeleccionada.option;

    // Validación
    if (filtroAplicar === 'empleado' && !selectedEmpleadoId) {
      return; // El botón ya está deshabilitado, pero por si acaso
    }

    // Llamar al padre con los parámetros
    const success = await onExecute(emp_id, option, {
      accion: accionSeleccionada,
      filtroTexto: filtroAplicar === 'todos'
        ? 'todos los clientes'
        : `clientes de ${selectedEmpleadoDesc}`,
    });

    if (success) {
      handleClose();
    }
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // Helpers para validación
  // ═══════════════════════════════════════════════════════════════════════════
  const isEjecutarDisabled = () => {
    if (isProcessing) return true;
    if (filtroAplicar === 'empleado' && !selectedEmpleadoId) return true;
    return false;
  };

  const getResumenTexto = () => {
    if (filtroAplicar === 'todos') return 'Todos los clientes';
    if (selectedEmpleadoDesc) return `Clientes de ${selectedEmpleadoDesc}`;
    return '(sin seleccionar)';
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box className="acciones-modal">
          {/* Header */}
          <div className="acciones-modal__header">
            <div className="acciones-modal__header-left">
              {accionSeleccionada && (
                <button className="acciones-modal__back-btn" onClick={handleVolverAcciones}>
                  ← Volver
                </button>
              )}
              <h2 className="acciones-modal__title">
                {accionSeleccionada
                  ? `${accionSeleccionada.icon} ${accionSeleccionada.titulo}`
                  : '⚙️ Acciones Masivas'}
              </h2>
            </div>
            <button className="acciones-modal__close-btn" onClick={handleClose}>✕</button>
          </div>

          {/* Body */}
          <div className="acciones-modal__body">

            {/* PASO 1: Lista de acciones */}
            {!accionSeleccionada && (
              <div className="acciones-modal__list">
                <p className="acciones-modal__subtitle">
                  Seleccioná una acción para aplicar a los clientes:
                </p>
                {accionesDisponibles.map((accion) => (
                  <button
                    key={accion.id}
                    className="acciones-modal__action-btn"
                    onClick={() => handleSelectAccion(accion)}
                  >
                    <span className="acciones-modal__action-icon">{accion.icon}</span>
                    <div className="acciones-modal__action-info">
                      <div className="acciones-modal__action-title">{accion.titulo}</div>
                      <div className="acciones-modal__action-desc">{accion.descripcion}</div>
                    </div>
                  </button>
                ))}
              </div>
            )}

            {/* PASO 2: Configurar filtros */}
            {accionSeleccionada && (
              <div className="acciones-modal__config">
                <p className="acciones-modal__subtitle">
                  {accionSeleccionada.descripcion}
                </p>

                {/* Selector de filtro */}
                <div className="acciones-modal__field">
                  <label className="acciones-modal__label">Aplicar a:</label>
                  <div className="acciones-modal__filter-btns">
                    {accionSeleccionada.filtros.includes('todos') && (
                      <button
                        className={`acciones-modal__filter-btn ${filtroAplicar === 'todos' ? 'active' : ''}`}
                        onClick={() => setFiltroAplicar('todos')}
                      >
                        👥 Todos los clientes
                      </button>
                    )}
                    {accionSeleccionada.filtros.includes('empleado') && (
                      <button
                        className={`acciones-modal__filter-btn ${filtroAplicar === 'empleado' ? 'active' : ''}`}
                        onClick={() => setFiltroAplicar('empleado')}
                      >
                        👤 Por empleado
                      </button>
                    )}
                  </div>
                </div>

                {/* Selector de empleado */}
                {/* Selector de empleado */}
                {filtroAplicar === 'empleado' && (
                  <div className="acciones-modal__field">
                    <label className="acciones-modal__label">Seleccionar empleado:</label>

                    {/* Usá directamente el EmpleadosModal - ya tiene su input */}
                    <EmpleadosModal
                      handleChange={handleEmpleadoIDChange}
                      handleDescChange={handleEmpleadoDescChange}
                      descSelected={selectedEmpleadoDesc}
                      onSelect={handleEmpleadoSelect}
                    />
                  </div>
                )}

                {/* Resumen y botón ejecutar */}
                <div className="acciones-modal__summary">
                  <div className="acciones-modal__summary-text">
                    <strong>Resumen:</strong><br />
                    Acción: {accionSeleccionada.titulo}<br />
                    Aplicar a: {getResumenTexto()}
                  </div>

                  <button
                    className={`acciones-modal__execute-btn ${isEjecutarDisabled() ? 'disabled' : ''}`}
                    onClick={handleEjecutarAccion}
                    disabled={isEjecutarDisabled()}
                  >
                    {isProcessing ? '⏳ Procesando...' : '✅ Ejecutar Acción'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </Box>
      </Modal>


    </>
  );
};

export default AccionesMasivasModal;
